<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <list-page
        :columns="columns"
        :headers="headers"
        :popupComponent="popupComponent"
        title="Special Client List"
        icon="mdi-shield-star"
        addButtonText="Special Client"
        stateendpoint="fixClient.fixClients"
        :basic-data="basicData"
        :actions="actions"
        :param1="1"
    />
  </div>
</template>
<script>
import ListPage from "../../components/ListPage";
import FixClientPopup from "../../components/popups/SpecialClientPopup";

export default {
  name: 'SpecialClients',
  metaInfo: {
    title: 'Exwebs',
    titleTemplate: 'Admin Dashboard - Special Clients | %s',
    meta: [
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' }
    ]
  },
  components: {ListPage, FixClientPopup},
  data() {
    return {
      headers: [
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Country',
          value: 'country'
        },
        {
          text: 'Percentage of Discount(%)',
          value: 'discount'
        },
        {
          text: '', value: 'actions', sortable: false
        }
      ],
      columns: [
        {value: 'action'},
      ],
      basicData: {
        type: 1,
        price: 0,
        linkPrice: 0,
        adultPrice: 0,
        discount: 0
      },
      actions: {
        load: 'loadFixClients',
        create: 'storeFixClient',
        update: 'updateFixClient',
        remove: 'removeFixClient',
        destroy: 'destroyFixClient'
      }
    }
  },
  computed: {
    popupComponent() {
      return FixClientPopup;
    }
  }
}
</script>
